import moment from 'moment';
import React from 'react';

import {CANONICAL_FORMAT} from 'util/DateConstants';
import {formalTime} from 'util/DateUtil';
import pickDefined from 'util/pickDefined';

import {DatetimeFilter, Operator} from '../SearchConstants';
import DatetimeFilterForm from './base/DatetimeFilterForm';
import {BASE_FILTER_FORM_PROP_NAMES, BaseFilterFormProps, FilterStyle} from './base/FilterFormConstants';

export interface DatetimeRangeFilterFormProps extends BaseFilterFormProps {
  filter: DatetimeFilter;
  filterStyle: FilterStyle;
  onChangeFilter: (filter: DatetimeFilter) => void;
  operators?: Array<Operator>;
  onRemove?: () => void;
}

export default function DatetimeRangeFilterForm(props: DatetimeRangeFilterFormProps): JSX.Element {
  const skeletonProps = pickDefined(props, ...BASE_FILTER_FORM_PROP_NAMES);
  const onChangeFilterValue = (value: {fromDatetime: string | null; toDatetime: string | null}): void => {
    props.onChangeFilter({
      ...props.filter,
      value,
    });
  };

  return (
    <DatetimeFilterForm
      {...skeletonProps}
      filterStyle={props.filterStyle}
      fromDatetime={
        props.filter.value.fromDatetime &&
        moment(props.filter.value.fromDatetime, [CANONICAL_FORMAT], true).isValid()
          ? formalTime(props.filter.value.fromDatetime)
          : props.filter.value.fromDatetime
      }
      toDatetime={
        props.filter.value.toDatetime &&
        moment(props.filter.value.toDatetime, [CANONICAL_FORMAT], true).isValid()
          ? formalTime(props.filter.value.toDatetime)
          : props.filter.value.toDatetime
      }
      onRemove={props.onRemove}
      onChangefromDatetime={(fromDatetime) => {
        onChangeFilterValue({...props.filter.value, fromDatetime});
      }}
      onChangetoDatetime={(toDatetime) => {
        onChangeFilterValue({...props.filter.value, toDatetime});
      }}
      operators={props.operators}
      selectedOperator={props.filter.operator}
      onChangeOperator={(operator) => {
        props.onChangeFilter({...props.filter, value: {fromDatetime: null, toDatetime: null}, operator});
      }}
    />
  );
}
